"use strict";

IREP.elkjop = (function () {

    var init = function () {
        if ($("#navbar").length == 0) {
            $("#logout").show();
        }
        IREP.callApi({ url: "/elkjop/traininginfo" }).done(function(data) {
            for (var i = 0, len = data.elkjopTrainings.length; i < len; i++) {
                if (data.elkjopTrainings[i].pass) {
                    var passedDiv = '<div class="passedTrainingBorder"><div></div></div>';
                    $("div[data-code='" + data.elkjopTrainings[i].code + "'").append(passedDiv);
                }
            }
        });
    };

    return {
        init:init
    };
})();